import { FederalStateEnum } from "@justhome/api-core";

export const federalStateLabels: Record<
  NonNullable<FederalStateEnum>,
  string
> = {
  SCHLESWIG_HOLSTEIN: "Schleswig-Holstein",
  HAMBURG: "Hamburg",
  NIEDERSACHSEN: "Niedersachsen",
  BREMEN: "Bremen",
  NORDRHEIN_WESTFALEN: "Nordrhein-Westfalen",
  HESSEN: "Hessen",
  RHEINLAND_PFALZ: "Rheinland-Pfalz",
  BADEN_WUERTTEMBERG: "Baden-Württemberg",
  BAYERN: "Bayern",
  SAARLAND: "Saarland",
  BERLIN: "Berlin",
  BRANDENBURG: "Brandenburg",
  MECKLENBURG_VORPOMMERN: "Mecklenburg-Vorpommern",
  SACHSEN: "Sachsen",
  SACHSEN_ANHALT: "Sachsen-Anhalt",
  THUERINGEN: "Thüringen",
};

export const getFederalStateOptions = () => {
  return Object.keys(federalStateLabels)
    .map((key) => ({
      value: key,
      label: federalStateLabels[key as keyof typeof federalStateLabels],
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};
